var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WorkPlace'),_c('Education'),_c('Profession')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }